import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  imageSrc: string;
  quote: string;
  author: string;
  result: string;
  imagePosition?: 'left' | 'right';
}
export function Testimonial({
  imageSrc,
  quote,
  author,
  result,
  imagePosition = 'left'
}: TestimonialProps) {
  return <div className="max-w-5xl mx-auto my-8 md:my-16 bg-white rounded-2xl shadow-sm border border-brand-cream overflow-hidden" data-id="element-170">
      <div className={`flex flex-col ${imagePosition === 'right' ? 'md:flex-row-reverse' : 'md:flex-row'}`} data-id="element-171">
        <div className="md:w-1/2 h-64 md:h-auto relative" data-id="element-172">
          <img src={imageSrc} alt={`Testimonial from ${author}`} className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-173" />
        </div>
        <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center bg-brand-cream/30" data-id="element-174">
          <Quote className="w-10 h-10 text-brand-gold mb-6 opacity-50" data-id="element-175" />
          <blockquote className="text-lg md:text-xl leading-relaxed text-brand-charcoal italic mb-6" data-id="element-176">
            "{quote}"
          </blockquote>
          <div data-id="element-177">
            <p className="font-bold text-brand-charcoal" data-id="element-178">{author}</p>
            <p className="text-brand-sage font-medium mt-1" data-id="element-179">Result: {result}</p>
          </div>
        </div>
      </div>
    </div>;
}